import { i as isDev } from "./env-da4fbb25.mjs";
const warn = (...attrs) => {
  if (isDev) {
    console.warn(...attrs);
  }
  return false;
};
export {
  warn as w
};
//# sourceMappingURL=console-42c8e8cc.mjs.map
